/* eslint-disable class-methods-use-this */
import { Injectable } from '@angular/core';

// tslint:disable-next-line: ban-types
declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  public eventEmitter(eventName: string, eventCategory: string, eventAction: string, eventLabel: string, eventValue: number): void {
      gtag('event', eventName, {
        eventCategory,
        eventLabel,
        eventAction,
        eventValue
      });
  }

  public itemAddedToCartConversion(value: number): void {
    gtag('event', 'conversion', {
      send_to: 'AW-10987744621/ReXHCLPNnOADEO3arvco',
      value,
      currency: 'USD',
      event_callback: ''
    });
  }

  public beginCheckoutConversion(cartTotal: number = 25): void {
    gtag('event', 'conversion', {
      send_to: 'AW-10987744621/xGG0CMnq1eEDEO3arvco',
      value: cartTotal,
      currency: 'USD',
      event_callback: ''
    });
  }
}

